import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=19fc4317&scoped=true&"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=19fc4317&prod&lang=scss&"
import style1 from "./SurveyQuestion.vue?vue&type=style&index=1&id=19fc4317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc4317",
  null
  
)

export default component.exports